import axios from 'axios';
import { ApiAbsence } from '@/rennovation/planning-view/types/api/absence-responses';

export class AbsenceApiService {
	private baseUrl = '/api/absences';

	async find(from: string, to: string, userId: string): Promise<ApiAbsence[]> {
		const response = await axios.get(`${this.baseUrl}?from=${from}&to=${to}&user=${userId}`);
		return response.data;
	}
}
